import {DocumentFilter} from '../ducks/documentUploadHistory';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse} from 'Shared/utilities/fetchHelpers';
import {Sort, toSortQuerystringParams} from 'Shared/components/PagedView/Table/Sort';
import DocumentRouteConstants from '../DocumentRouteConstants';

export default {
  fetchDocuments: async (filter?: DocumentFilter, sort?: Sort) => {
    const response = await axiosInstance.get(DocumentRouteConstants.DOCUMENT_UPLOAD_HISTORY_API('1'), {
      params: {
        ...filter,
        ...(sort && toSortQuerystringParams(sort)),
      },
      ...getAxiosConfig(),
    });
    return handleResponse(response);
  },
};
